// extracted by mini-css-extract-plugin
export var alertIcon = "_qe-0";